import React from 'react';
import moment, { type Moment } from 'moment';

// Components
import InputWrapper from '../InputWrapper';
import DatePicker from 'components/common/datepicker/DatePicker';

// Utils
import { getFormattedDate } from 'utils/date';

type DateSelectChangeEvent = {
  target: {
    name?: string;
    value: string;
  };
};

type DateSelectBlurEvent = {
  target: {
    name?: string;
  };
};

interface Props {
  label?: string;
  error?: React.ReactNode;
  isMandatory?: boolean;
  onBlur?: (e: DateSelectBlurEvent) => void;
  value?: string;
  onChange: (e: DateSelectChangeEvent) => void;
  name?: string;
  customClassName?: string;
  /** When true, the day cannot be selected (react-dates SingleDatePicker). */
  isOutsideRange?: (day: Moment) => boolean;
  disabled?: boolean;
}

const DateSelect: React.FC<Props> = ({
  label,
  error,
  isMandatory,
  onBlur,
  value,
  onChange,
  name,
  customClassName,
  isOutsideRange,
  disabled,
}) => {
  const handleOnChange = (selectedDate: moment.Moment | null) => {
    const formattedDate = getFormattedDate(selectedDate || undefined);
    onChange({
      target: {
        name,
        value: formattedDate,
      },
    });
  };

  const handleBlur = () => {
    if (onBlur) {
      onBlur({
        target: {
          name,
        },
      });
    }
  };

  return (
    <InputWrapper label={label} error={error} isMandatory={isMandatory}>
      <DatePicker
        customClassName={customClassName}
        hasError={!!error}
        placeholderText="Select Date"
        date={moment(value).isValid() ? moment(value) : null}
        onDateChange={handleOnChange}
        onBlur={handleBlur}
        {...(isOutsideRange === undefined ? {} : { isOutsideRange })}
        disabled={disabled}
      />
    </InputWrapper>
  );
};

export default DateSelect;
